import { Image, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";
import NavigationButtons from "src/components/NavigationButtons";
import { SceneLayout } from "src/components/SceneLayout";
import getImageSrc from "src/utils/getImageSrc";

export default function SetUpFamilyAccount({ flow, mode }) {
  const { t } = useTranslation();
  return (
    <>
      <NavigationButtons mode={mode} onBack={flow.previous} />
      <SceneLayout
        centerProps={{ width: "320px" }}
        center={
          <>
            <Image src={getImageSrc("account.svg")} width="176px" />
            <H2 color="highEmphasis" textAlign="center" mt="24px">
              {t("buttons.setUpFamilyAccount")}
            </H2>
            <BodyText mt="8px" color="highEmphasis" textAlign="center">
              {t("wizard.promotion.createAccount.text")}
            </BodyText>
            <Button
              variant="flatPrimary"
              mt="8px"
              onClick={() => flow.push("what-is-family-account")}
            >
              {t("whatIsFamilyAccount")}
            </Button>
          </>
        }
        bottomProps={{ mb: "24px" }}
        bottom={
          <>
            <Button
              variant="containedPrimary"
              onClick={() => flow.push("initial-sign-up")}
              minWidth="120px"
            >
              {t("buttons.createAccount")}
            </Button>
          </>
        }
      />
    </>
  );
}
